export default {
	IMAGE: 'image',
	IMAGE_NO_PDF: 'image-nopdf',
	AUDIO: 'audio',
	VIDEO: 'video',
	PDF: 'pdf',
	PPT: 'ppt',
	ZIP: 'zip',
	GIF: 'gif',
}
